import React from 'react';

const LinkedIn = () => (
	<svg viewBox="0 0 48 48" className="icon linkedin">
		<path d="M36,34a2,2,0,0,1-2,2H14a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H34a2,2,0,0,1,2,2ZM17.41,15.36a2,2,0,1,0,0,4,2,2,0,1,0,0-4Zm1.83,17V20.64H15.59V32.38Zm2.33,0h3.65V25.61a2.51,2.51,0,0,1,.14-.91,1.91,1.91,0,0,1,1.85-.88,1.88,1.88,0,0,1,1.85,2.05v6.5H32.7v-7c0-3.46-1.8-5-4.2-5a4.3,4.3,0,0,0-3.62,1.87h-.07l-.17-1.61H21.47c0,1,.1,2.28.1,3.74Z"/>
  </svg>
);

export default LinkedIn;
